import { gql } from '@apollo/client';

const fields = gql`
    fragment NewsletterPreferenceFields on NewsletterPreferences {
        revision
        intent
        source
        providerStatus
        syncPending
        error
        result
        canSubscribe
        reconfirmationRequired
    }
`;
export const NEWSLETTER_PREFERENCES = gql`
    query NewsletterPreferences($registrationOnly: Boolean) {
        newsletterPreferences(registrationOnly: $registrationOnly) {
            ...NewsletterPreferenceFields
        }
    }
    ${fields}
`;
export const SET_NEWSLETTER_PREFERENCE = gql`
    mutation SetNewsletterPreference(
        $action: NewsletterAction!
        $requestId: String!
        $expectedRevision: Int!
        $wordingVersion: String
    ) {
        setNewsletterPreference(
            action: $action
            requestId: $requestId
            expectedRevision: $expectedRevision
            wordingVersion: $wordingVersion
        ) {
            ...NewsletterPreferenceFields
        }
    }
    ${fields}
`;
